// components/Layout.js
import React, { useState, useEffect } from "react";
import CustomSidebar from "./CustomSidebar"; // Assuming path is correct
import Navbar from "./Navbar"; // Assuming path is correct
import { Outlet, useLocation } from "react-router-dom";

const Layout = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false); // Default to not collapsed
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768); // Example breakpoint for mobile

  // Handle sidebar collapse on mobile:
  // - Start collapsed on mobile
  // - Auto-collapse when navigating on mobile if it was open
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768; // md breakpoint
      setIsMobile(mobile);
      if (mobile) {
        setCollapsed(true); // Always collapse sidebar on mobile view initially or on resize to mobile
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Call on initial mount

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // If on mobile and sidebar was open, collapse it on route change
    if (isMobile) {
      setCollapsed(true);
    }
  }, [location.pathname, isMobile]);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  // The routing logic in App.js ensures that this Layout component is only rendered
  // for authenticated users on appropriate routes (e.g., /dashboard/*).
  // So, the isLayoutHidden check might not be needed here if AddInfo, etc., are separate routes.

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      {" "}
      {/* Light base background */}
      {/* Sidebar */}
      <CustomSidebar collapsed={collapsed} toggleSidebar={toggleSidebar} />
      {/* Main Content Area */}
      {/* Apply margin-left based on sidebar state. Use fixed pixel values for precision. */}
      {/* Tailwind's w-64 is 256px, w-20 is 80px. Adjust if your sidebar has different widths. */}
      <div
        className={`flex flex-col flex-1 min-w-0 transition-all duration-300 ease-in-out
                   ${collapsed ? (isMobile ? "ml-0" : "ml-[80px]") : isMobile ? "ml-0" : "ml-64"}`}
        // If sidebar is overlay on mobile, main content doesn't need margin.
        // If sidebar pushes content on mobile, then ml-64 or similar would be needed when open.
        // This example assumes sidebar overlays on mobile or is hidden, so ml-0 when mobile.
      >
        {/* Navbar */}
        <div
          className="h-16 bg-white shadow-sm flex-shrink-0 sticky top-0 z-30" // Added sticky, z-index
        >
          <Navbar
            toggleSidebar={toggleSidebar}
            isSidebarCollapsed={collapsed}
          />{" "}
          {/* Pass toggle and state to Navbar for hamburger */}
        </div>

        {/* Page Content - Takes remaining space, scrolls independently */}
        <main className="flex-1 p-4 md:p-6 lg:p-8 overflow-auto">
          <Outlet /> {/* Child routes defined in App.js will render here */}
        </main>
      </div>
    </div>
  );
};

export default Layout;
